// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';

//Modules

//Components

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { WebServices } from '../../shared/services/webServices';
import { CPDFormatters } from '../../shared/services/cpd-formatters';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Third Party
import moment from 'moment';

//Models
import { dto_for_UpdateStatePracticeAdoptions } from "../../shared/dtos/practices/dto_for_UpdateStatePracticeAdoptions.js";

//Local Services
//import { FormDataService } from '../../shared/services/formData';
import { Helpers } from '../../shared/services/helpers.js';

//Token
import { authToken } from '../../shared/authToken';
import { FormAction } from '../../shared/classes/formAction';



// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// PracticesViewComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    template : '<div class="sp-main-div" data-test-id="content_select_practice">\n\n    <!--UPPER-->\n    <div class="sp-upper-div">\n\n        <!--Title-->\n        <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n\n        <div style="margin:0 10px 5px 20px; font-style:italic">Select the items you wish to be included for your state. Your choices will be preserved as you change pages (so long as you don\'t click refresh or navigate away). Once complete, click on "Save Selected Assets" to save all of these changes to the database.</div>\n\n        <!--Filter Controls Div-->\n        <div *ngIf="authToken.IsState()" class="sp-control-div" role="radiogroup" aria-labelledby="divRadioLabel">\n\n            <div id="divRadioLabel">Filter By:</div>\n            <!--ALL-->\n            <div class="sp-filter-radio" (click)="_FilterUpdate(\'all\')" (keyEnter)="_FilterUpdate(\'all\')">\n                <input checked="checked" tabindex="0" id="rdoShowAll" type="radio" value="all" name="practiceFilter" />\n                <label for="rdoShowAll" aria-label="No practice filter" class="cpd-focusable">All</label>\n            </div>\n\n            <!--ACTIVE-->\n            <div class="sp-filter-radio" (click)="_FilterUpdate(\'selected\')" (keyEnter)="_FilterUpdate(\'selected\')">\n                <input tabindex="0" id="rdoShowSelected" type="radio" value="active" name="practiceFilter" />\n                <label for="rdoShowSelected" class="cpd-focusable">Selected</label>\n            </div>\n\n            <!--DELETED-->\n            <div class="sp-filter-radio" (click)="_FilterUpdate(\'unselected\')" (keyEnter)="_FilterUpdate(\'unselected\')">\n                <input tabindex="0" id="rdoShowUnselected" type="radio" value="deleted" name="practiceFilter" />\n                <label for="rdoShowUnselected" class="cpd-focusable">Unselected</label>\n            </div>\n\n            <div style="min-width:10px; min-height:20px; border-left:solid 1px #999; margin-left:10px;"></div>\n\n            <!--ASSET TYPE FILTER-->\n            <div>\n                <label for="selAssetTypeFilter" aria-label="Asset Type Filter" title="Asset Type Filter">Asset Type:</label>\n                <select id="selAssetTypeFilter" [(ngModel)]="_selectedAssetTypeFilter" (change)="assetFilterChanged($event)">\n                    <option *ngFor="let assetType of _assetTypeFilters;" [ngValue]="assetType">{{assetType.practice_type_code_display}}</option>\n                </select>\n            </div>\n        </div>\n\n        <!--County Div-->\n        <!--<div style="flex-grow:0; margin:5px 0 10px 10px;">\n            <select *ngIf="requireCounty" (change)="ChangeCounty($event)">\n                <option value="">Select a county</option>\n                <option *ngFor="let county of counties" value="{{county.code}}">{{county.name}}</option>\n            </select>\n        </div>-->\n\n    </div>\n\n    <!--LOWER-->\n    <div class="sp-lower-div">\n\n        <!--Grid Div-->\n        <!--<div class="sp-grid-div" style="border-top:solid 2px green; border-bottom:solid 2px red;">-->\n            <cas-grid #stateManagementGrid\n                [settings]="stateManagementGridSettings" summary="Asset List" \n                (onRefreshClicked)="gridRefreshClicked()" \n                (onRowSelectionChanged)="gridSelectionChanged()" \n                \n                (onRowSelected)="gridRowSelected($event)"\n                (onRowUnSelected)="gridRowUnSelected($event)"\n\n                (onSearch)="onGridSearch($event)">\n            </cas-grid>\n        <!--</div>-->\n\n    </div>\n\n</div>',
    styles : ['.sp-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.sp-upper-div{flex-grow:0}.sp-control-div{display:flex;align-items:center;margin:20px 0 10px 0;padding-left:20px;font-size:12px}.sp-filter-radio{padding-left:10px;display:flex;align-items:center}.sp-lower-div{position:relative;flex-grow:1;border-top:solid 1px #ccc}.sp-grid-div{overflow-x:auto;border-top:solid 1px #ccc;position:relative}.sp-practicesGrid-grid{border-top:solid 1px #999}'],
    //providers:[ FormDataService ],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class SelectPracticeComponent {

    @ViewChild('stateManagementGrid') stateManagementGrid;
    
    // Boilerplate
    _componentName = "SelectPracticeComponent";
    _title = "";
    authToken = authToken;
    _disposalFunctions = [];

	//Class wide member reference for the growls control
	growlBox = null;

    _selectedCounty = "";
    requireCounty = false;
    counties = [];

    _assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }];
    _selectedAssetTypeFilter = this._assetTypeFilters[0];

    // Track the practice changes we want to make in obj format so we can make indexed changes
    _practicesByIdToAdd = {}
    _practicesByIdToRemove = {}

    _FilterUpdate( filter ){
        if( filter === "all" ){
            this.stateManagementGrid.ClearFilters();
        }
        else{
            //this.stateManagementGrid.SetFilter( row => ( filter === 'selected' && row.__selected ) || ( filter === 'unselected' && !row.__selected ) );
            this.stateManagementGrid.SetFilter(
                "default",
                row => (( filter === 'selected' && row.__selected ) || ( filter === 'unselected' && !row.__selected )),
                true);
        }
        
    }

    stateManagementGridSettings = {
        cssClasses_Grid:"sp-practicesGrid-grid",
        //cssClasses_Headers:"sp-practicesGrid-columnHeaderRow",
        //cssClasses_ColumnHeaderRow:"sp-practicesGrid-columnHeaderRow",
        hideClearSelectedButton:true,
        hideSearchBox: false,
        multiSelect: true,
        positionAbsolute:true,
        //rowsPerPage:29,
        showCheckboxColumn:true,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"practice_code",
        rowIdentityPrefixForJAWS:"Asset Code",
        columns: [
            { fieldName:'practice_code', display:'Code', width:'10%', minWidth:30 },
            { fieldName:'practice_name', display:'Asset', width:'40%', minWidth:100 },
            { fieldName:'measurement_unit_display', display:'Units', width:'10%', minWidth:25 },
            { fieldName:'status', display:'Status', width:'10%', minWidth:50 },
            { fieldName:'start_date', display:'Effective', width:'10%', minWidth:75, procDataFn: x => this._FormatDate( x ) },
            { fieldName:'sunset_date', display: 'Sunset Date', width: '10%', minWidth: 75, procDataFn: x => this._FormatDate(x) },
            { fieldName:'state_end_date', display:'State End Date', width:'10%', minWidth:75, procDataFn: x => this._FormatDate( x ) },
            { fieldName:'installed_practice_lifespan_years', display:'Lifespan', width:'10%', minWidth:60 }
        ],
        rows: []
    };

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    constructor(
        casNavBoxService:CASNavBoxService,
        cpdFormatters: CPDFormatters,
        helpers: Helpers,
        webServices:WebServices, 
        //formData: FormDataService,
        cdRef: ChangeDetectorRef) {

        this.constructor.mapParams( this, arguments );
      
        // Handle clicks on the NavBox actions
        //-------------------------------------------
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.NavBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Debugging
        //-------------------------------------------
        casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("zRoles Test");
        disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
            this._debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);

        //Set Title
        this._title = "Select Assets Approved for State Use";

    // (note that the local user was removed years ago by the user, and is unlikely to return.. may wan to pull all this at some point)
    //    if (authToken.IsLocal()){
    //        this._title = "Select Assets For Local Use";
    //    }
    //    else{
    //        this._title = "Select Assets Approved for State Use";
    //    }
    }

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.setNavBoxActions();
    }

    //=====================================
    // ngAfterViewInit
    //=====================================
    ngAfterViewInit() {
        this.initalizeGrowlBox();
        this.set508();

        // Make sure the grid object is loaded before continuing
        this.helpers.executeOnCondition (
            () => { return !!this.stateManagementGrid; },
            () => {
                this.LoadPractices();
                this.LoadAssetTypes();
                this.cdRef.detectChanges();
            }
        );
    }

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };


    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // assetFilterChanged
    //==================================
    assetFilterChanged(e) {
        this.LoadPractices();
    };

    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry) {

    }

    //==================================
    // _FormatDate
    //==================================
    _FormatDate(dateString) {
        let date = moment(dateString);
        return date.isValid() ? date.format('MM-DD-YYYY') : "";
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        this.LoadPractices();
    }

    //==================================
    // gridRowSelected
    //==================================
    gridRowSelected(evt){

        //console.log("gridRowSelected", evt);

        let practiceId = evt.practice_id;

        if (this._practicesByIdToRemove[practiceId]){
            delete this._practicesByIdToRemove[practiceId];
        }
        else{
            this._practicesByIdToAdd[practiceId] = practiceId;
        }

        //console.log("_practicesByIdToAdd", this._practicesByIdToAdd);
        //console.log(Object.values(this._practicesByIdToAdd));
        //console.log("_practicesByIdToRemove", this._practicesByIdToRemove);
        //console.log(Object.values(this._practicesByIdToRemove));
        //console.log("--------------------------------------------------");
        
    }

    //==================================
    // gridRowUnSelected
    //==================================
    gridRowUnSelected(evt){
        //console.log("gridRowUnSelected", evt);

        let practiceId = evt.practice_id;

        if (this._practicesByIdToAdd[practiceId]){
            delete this._practicesByIdToAdd[practiceId];
        }
        else{
            this._practicesByIdToRemove[practiceId] = practiceId;
        }

        //console.log("_practicesByIdToAdd", this._practicesByIdToAdd);
        //console.log(Object.values(this._practicesByIdToAdd));
        //console.log("_practicesByIdToRemove", this._practicesByIdToRemove);
        //console.log(Object.values(this._practicesByIdToRemove));
        //console.log("--------------------------------------------------");
    }

    //==================================
    // gridSelectionChanged
    //==================================
    gridSelectionChanged() {
        this.casNavBoxService.EmphasizeActionByName("act_save_selected_practices");
    };

    //==================================
    // NavBoxActionClicked
    //==================================
    NavBoxActionClicked(action) {
        switch (action.field_name) {
            case "act_save_selected_practices":
                this.Save();
                break;
        }
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (let i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText) {

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0) {
            this.stateManagementGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return row.practice_code.toLowerCase().indexOf(searchText) >= 0 || row.practice_name.toLowerCase().indexOf(searchText) >= 0;
        };

        //Set the "search" filter on the grid
        this.stateManagementGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //====================================
    // set508
    //====================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //ChangeCounty(e){
    //    this._selectedCounty = e.target.value;
    //    this.LoadPractices();
    //}

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        //  Currently, only one role can access this screen (State Data Steward), so there's no need to evaluate roles for these action links
        actions.push(new FormAction("act_save_selected_practices", "<u>S</u>ave Selected Assets", true, null, "s"));

        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // LoadAssetTypes
    //==================================
    LoadAssetTypes(callback) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: false
            }
        })
            .then(res => {
                console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Build the asset types list
                this._assetTypeFilters = [{ practice_type_code_display: "All", practice_type_code: "" }].concat(dto);
                this._selectedAssetTypeFilter = this._assetTypeFilters[0];
                if (callback) { callback(); }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
                console.log("[ERROR][{0}:_loadAssetTypes()]".format(this._componentName), err);
            });

    }

    //==================================
    // LoadPractices
    //==================================
    LoadPractices(callback){

        this.stateManagementGrid.MarkAsLoading(true);

        this.casNavBoxService.DeEmphasizeActionByName("act_save_selected_practices");

        this._practicesByIdToAdd = {}
        this._practicesByIdToRemove = {}

        this.webServices.Get({
            apiPath: "/practices/getPracticeApprovalByState",
            args: {
                assetTypeCode: this._selectedAssetTypeFilter.practice_type_code,
            }
        })
            .then((res) => { 

            let dto = res.data.DTO;

            this.stateManagementGrid.SetRows(dto);
            this.stateManagementGrid.GoToFirstPage();

            setTimeout(()=>{ 
                this.stateManagementGrid.SortGrid("practice_code", "A");
            } ,0);
                
            this.stateManagementGrid.MarkAsLoading(false);

            if (callback){ callback(); }
        })
        .catch( (err) => { 
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) );
            this.stateManagementGrid.MarkAsLoading(false);
            });
    }

    //==================================
    // Save
    //==================================
    Save(){

        //Clear action emphasis
        this.casNavBoxService.DeEmphasizeActionByName("act_save_selected_practices");

        //Put changes into a dto
        let dto = new dto_for_UpdateStatePracticeAdoptions();
        dto.practicesByIdToAdd = Object.values(this._practicesByIdToAdd);
        dto.practicesByIdToRemove = Object.values(this._practicesByIdToRemove);

        //Do we have any changes?
        if (dto.practicesByIdToAdd.length == 0 && dto.practicesByIdToRemove.length == 0){
            this.growlBox.addGrowl("warn", "No changes detected");
            return;
        }

        //Prep for save
        this.casNavBoxService.DisableAllLinks();
        this.growlBox.addGrowl("info", "Saving...");
        this.stateManagementGrid.MarkAsLoading(true);

        //Do the deed
        this.webServices.Post("/practices/updateStatePracticeAdoptions", dto)
        .then(()=>{  
            this.growlBox.addGrowl("success", "Record Saved");
            this.casNavBoxService.EnableAllLinks();
            this.stateManagementGrid.MarkAsLoading(false);
        })
        .catch((err) => { 
            this.casNavBoxService.EnableAllLinks();
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) ) ;
            this.stateManagementGrid.MarkAsLoading(false);
        });
        

        ////////////////////////////////////////

        ////Prep the UI for a save
        //this.casNavBoxService.DisableAllLinks();
        //this.growlBox.addGrowl("info", "Saving...");
        //this.stateManagementGrid.MarkAsLoading(true);

        //let selectedPractices = this.stateManagementGridSettings.rows
        //    .filter( x => x.__selected == true )
        //    .map( x => x.practice_id );

        ////this.webServices.Batch("/@SelectPractices", { setPractices: selectedPractices, countyCode: this._selectedCounty });
        //this.webServices.Post("/practices/setPracticesElectedByState", selectedPractices)
        //.then(()=>{  
        //    this.growlBox.addGrowl("success", "Record Saved");
        //    this.casNavBoxService.EnableAllLinks();
        //    //this.casNavBoxService.DeEmphasizeActionByName("act_save_selected_practices");
        //    //this.casNavBoxService.DisableActionByName("act_save_selected_practices");
        //    //this.stateManagementGridSettings.loading = false;
        //    this.stateManagementGrid.MarkAsLoading(false);
        //})
        //.catch((err) => { 
        //    this.casNavBoxService.EnableAllLinks();
        //    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err) ) ;
        //    //this.casNavBoxService.DeEmphasizeActionByName("act_save_selected_practices");
        //    //this.casNavBoxService.DisableActionByName("act_save_selected_practices");
        //    //this.stateManagementGridSettings.loading = false;
        //    this.stateManagementGrid.MarkAsLoading(false);
        //});
    };

}